// automatically generated by the FlatBuffers compiler, do not modify

export enum Precision {
  HALF = 0,
  SINGLE = 1,
  DOUBLE = 2
}
